import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Nov 26 2018
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { NotificationConverter, jsonConversions, NotificationState } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import logger from '../../../shared/logger';
import api from '../../api';
import { GenericTransportLayer } from '../GenericTransportLayer';
export var NotificationLayer =
/*#__PURE__*/
function (_GenericTransportLaye) {
  _inherits(NotificationLayer, _GenericTransportLaye);

  function NotificationLayer() {
    var _this;

    _classCallCheck(this, NotificationLayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NotificationLayer).call(this, CONSTANTS.API.ENDPOINTS.NOTIFICATIONS));

    _this.delete = function (ids) {
      return api(_this.baseUri).delete({
        data: {
          notificationIds: ids
        }
      }).then(function (response) {
        return Promise.resolve(response.data.result);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };

    return _this;
  }

  _createClass(NotificationLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }, {
    key: "getNewNotifications",
    value: function getNewNotifications(limit) {
      var _this2 = this;

      return api(CONSTANTS.API.ENDPOINTS.NOTIFICATIONS_LIMIT(limit)).get({
        responseType: 'json'
      }).then(function (response) {
        return {
          totalCount: response.data.result.totalCount,
          notifications: response.data.result.notifications.map(function (item) {
            return _this2.converter.toObject(item, jsonConversions);
          })
        };
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "markAsRead",
    value: function markAsRead(ids) {
      return api(CONSTANTS.API.ENDPOINTS.NOTIFICATIONS_MARK_AS_READ).post({
        notificationIds: ids,
        state: NotificationState.read
      }).then(function (response) {
        return Promise.resolve(response.data.result);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return NotificationLayer;
}(GenericTransportLayer);

__decorate([Inject, __metadata("design:type", NotificationConverter)], NotificationLayer.prototype, "converter", void 0);